import React from "react";
import { useHistory } from "react-router-dom";
import ContentWrapper from "../../components/common/AssessmentContentWrapper";
import { routes } from "../../helper/routes";
import QuestionEditorForm from "./QuestionEditorForm";
import { QuestionEditorProvider } from "../../context/assessSections/QuestionEditorContext";

export default function CreateQuestionPage() {
  const history = useHistory();

  return (
    <ContentWrapper>
      <QuestionEditorProvider>
        <QuestionEditorForm
          title="Create Question"
          onBack={() => history.push(routes.ques_lib)}
          onCancel={() => history.push(routes.ques_lib)}
        />
      </QuestionEditorProvider>
    </ContentWrapper>
  );
}